import COUNTRY_CODES from '../_shared/types/countryCodes';
import DealerType from '../_shared/types/user';
import Singleton from '../Singleton';
import ErrorService from './ErrorService';
import InfoError from '../_shared/models/InfoError';
import ROUTES from '../components/Routes/constants';

export default class IntercomService extends Singleton<IntercomService> {
  static init = user => {
    try {
      if (process.env.REACT_APP_INTERCOM_TOKEN) {
        let intercomSettings = null;
        if (user) {
          intercomSettings = {
            app_id: process.env.REACT_APP_INTERCOM_TOKEN,
            user_id: IntercomService.getDistinctId(user),
            name: user.fullName,
            email: user.email,
            is_csu: user?.superUserId && user?.superUserId !== user?.id,
            can_buy: user.isCanBuy,
            can_sell: user.isCanSell,
            platform: 'Web5'
          };
        } else if (
          window.location.pathname.includes(ROUTES.RETAIL_PUBLIC_BASE)
        ) {
          intercomSettings = {
            app_id: process.env.REACT_APP_INTERCOM_TOKEN,
            platform: 'Web5'
          };
        }
        const w = window;
        const ic = w.Intercom;
        if (typeof ic === 'function') {
          // if (window.location.pathname !== ROUTES.BUYING_PURCHASE) {
          ic('reattach_activator');
          if (intercomSettings) {
            ic('update', intercomSettings);
          }
          // }
        } else {
          const d = document;
          const i = function iArg(...args) {
            i.c(args);
          };
          i.q = [];
          i.c = function iPush(args) {
            i.q.push(args);
          };
          w.Intercom = i;
          const l = function intercomScript() {
            const s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = `https://widget.intercom.io/widget/${process.env.REACT_APP_INTERCOM_TOKEN}`;
            const x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
          };
          if (w.attachEvent) {
            w.attachEvent('onload', l);
          } else {
            w.addEventListener('load', l, false);
          }
        }
      }
    } catch (err) {
      ErrorService.trackError(
        new InfoError(`Error initializing Intercom Service ${err}`)
      );
    }
  };

  static getDistinctId = user => {
    const regionCode =
      user.country.shortName === 'CA' ? COUNTRY_CODES.CA : COUNTRY_CODES.US;
    if (user.superUserType && user.superUserType === DealerType.universalUser) {
      return IntercomService.calcDistinctId(regionCode, user.superUserId);
    }
    if (user) {
      return IntercomService.calcDistinctId(regionCode, user.id);
    }
    return '';
  };

  static calcDistinctId = (regionId, userId) => {
    return `${regionId}_${userId}`;
  };

  static trackEvent = (eventName, metadata) => {
    const intercom = window.Intercom;
    if (typeof intercom === 'function') {
      intercom('trackEvent', eventName, metadata || {});
    }
  };

  static shutdown = () => {
    const intercom = window.Intercom;
    if (typeof intercom === 'function') {
      intercom('shutdown');
    }
  };
}
